import _slicedToArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import ApprovalRequest from 'src/store/models/ApprovalRequest';
import Entry from 'src/store/models/Entry';
import User from 'src/store/models/User';
import Expense from 'src/store/models/Expense';
import { dialog } from 'src/boot/mixins.js';
import moment from 'moment';
export default {
  mixins: [dialog],
  props: {
    approvalRequestId: {
      type: Number,
      default: null
    },
    dateFrom: {
      type: String,
      required: true
    },
    dateTo: {
      type: String,
      required: true
    },
    onSubmit: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      notes: '',
      totalExpenses: 0,
      totalMinutes: 0,
      loading: true
    };
  },
  computed: {
    humanReadableTimeframeLabel: function humanReadableTimeframeLabel() {
      return "".concat(this.dateFrom ? moment(this.dateFrom).format("MMM D".concat(moment(this.dateFrom).year() !== moment(this.dateTo).year() ? ', YYYY' : '')) : '', " - ").concat(this.dateTo ? moment(this.dateTo).format('MMM D, YYYY') : '');
    }
  },
  methods: {
    submitForApproval: function submitForApproval() {
      var _this = this;

      this.$q.loading.show();

      if (this.approvalRequestId) {
        ApprovalRequest.api().resubmit(this.approvalRequestId, {
          event_notes: this.notes
        }).then(function () {
          var message = _this.$t('components.approvalsDialog.timesheet_and_expenses_resubmitted');

          if (!_this.me.account.hasFeature('expenses_management')) {
            message = _this.$t('components.approvalsDialog.timesheet_resubmitted');
          }

          _this.$q.notify({
            message: message,
            color: 'positive'
          });

          _this.onSubmit();
        }).finally(function () {
          _this.$q.loading.hide();

          _this.hide();
        });
      } else {
        ApprovalRequest.api().submit({
          date_from: this.dateFrom,
          date_to: this.dateTo,
          event_notes: this.notes
        }).then(function () {
          var message = _this.$t('components.approvalsDialog.timesheet_and_expenses_submitted');

          if (!_this.me.account.hasFeature('expenses_management')) {
            message = _this.$t('components.approvalsDialog.timesheet_submitted');
          }

          _this.$q.notify({
            message: message,
            color: 'positive'
          });

          _this.onSubmit();
        }).finally(function () {
          _this.$q.loading.hide();

          _this.hide();
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var params = {
      date_from: this.dateFrom,
      date_to: this.dateTo,
      member_ids: [User.me().user_id],
      no_paginate: 1
    };
    var fetchPromises = [Entry.api().fetch({
      params: params,
      save: false
    })];

    if (this.me.account.hasFeature('expenses_management')) {
      fetchPromises.push(Expense.api().fetch({
        params: params,
        save: false
      }));
    }

    Promise.all(fetchPromises).then(function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        data: []
      },
          _ref2 = _slicedToArray(_ref, 2),
          entries = _ref2[0],
          expenses = _ref2[1];

      _this2.totalMinutes = entries.data.reduce(function (acc, entry) {
        return acc + entry.entry_minutes;
      }, 0);

      if (_this2.me.account.hasFeature('expenses_management')) {
        _this2.totalExpenses = expenses.data.reduce(function (acc, expense) {
          return acc + parseFloat(expense.calculated_amount);
        }, 0);
      }
    });
  }
};